/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  /*============================================================================
    Open external links (rich text, menus, etc.) in a new tab
  ==============================================================================*/
  function markLinkIfExternal(link) {
    var href = link.getAttribute("href");

    if (!href || href.charAt(0) === "#" || href.indexOf("mailto:") === 0 || href.indexOf("tel:") === 0) {
      return;
    }

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    if (url.hostname === window.location.hostname) {
      return;
    }

    link.setAttribute("target", "_blank");

    var rel = (link.getAttribute("rel") || "").split(" ").filter(Boolean);
    ["noopener", "noreferrer"].forEach(function (value) {
      if (rel.indexOf(value) === -1) rel.push(value);
    });
    link.setAttribute("rel", rel.join(" "));
  }

  function markExternalLinksIn(root) {
    if (root.nodeType !== 1) return;

    if (root.tagName === "A" && root.hasAttribute("href") && !root.hasAttribute("target")) {
      markLinkIfExternal(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll("a[href]:not([target])").forEach(markLinkIfExternal);
    }
  }

  DOMready(function () {
    markExternalLinksIn(document.body);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(markExternalLinksIn);
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
